let TranslationPlugin = {};

TranslationPlugin.install = function (Vue, {router, store}) {

    const IS_DEBUG_ENABLED = false; // Set to true if you want to see debug info (show on page the keys instead of translated text if translation not found, show console logs when translation not found).

    const storeModuleName = "TranslationStore";
    let state = store.state[storeModuleName];


    let replaceVars = (text, variables) => {
        let modifiedText = text;
        if (typeof variables !== "undefined" && variables.length > 0) {

            for (let i in variables) {
                modifiedText = modifiedText.replace("{"+i+"}", variables[i])
            }
        }

        return modifiedText;
    };


    /**
     * Translate a text.
     * @param {String} textKey
     * @param {Array} variables (optional) - Array with strings that will replace variables (i.e. {0}, {1}, {2}, ...) in translated text.
     * @param {Boolean} mustUseKeyAsFallback (optional. Default: false) - When this is TRUE, return the key if translation can't be found. Otherwise, return an empty string if translation can't be found.
     * @return {String} - Text in selected language or given text key if the text couldn't be found.
     */
    let translateText = (textKey, variables, mustUseKeyAsFallback) => {

        if (typeof variables === "undefined" || variables === null) {
            variables = [];
        }
        if (typeof mustUseKeyAsFallback !== "boolean") {
            mustUseKeyAsFallback = false;
        }

        let textToReturn = "";
        let selectedLanguage = state.selectedLanguage;

        if (typeof state.texts[textKey] === "undefined") {
            if (IS_DEBUG_ENABLED) {
                console.log("No translation found for: ", selectedLanguage + "." + textKey);
                textToReturn = selectedLanguage + "." + textKey; // If translation is not found, return "<language>.<key>".
            }
            else if (mustUseKeyAsFallback === true) {
                textToReturn = textKey; // If translation is not found and mustUseKeyAsFallback is true, return "<key>".
            }
        }
        else {
            // Text key found, proceed to translation.
            let translatedText = state.texts[textKey];
            translatedText = replaceVars(translatedText, variables);

            textToReturn = translatedText;
        }

        return textToReturn;
    };


    // Load translations from server.
    let promiseApplicationDataLoaded = store.dispatch(storeModuleName + '/loadTranslationData');

    promiseApplicationDataLoaded.then((response) => {

        let currentRoute = router.history.current;

        if (store.getters["UserStore/getCurrentAppType"] === store.getters["UserStore/getAppTypes"].PF_CHATBOT_STUDY) {

            // ===== AppType is PF_CHATBOT_STUDY. =====

            if (store.getters["UserStore/getIsUserLoggedIn"] === true) {
                router.push({ name: 'PF_ChatBotPage'});
            }
            else {
                router.push({ name: 'BlankPage'});
            }
        }
        else {
            if (store.getters["UserStore/getCurrentAppType"] === store.getters["UserStore/getAppTypes"].PF_CHATBOT_PUBLIC && window.location.pathname.indexOf("/voucher") === -1) {

                // ===== AppType is PF_CHATBOT_PUBLIC. =====

                let chatbotRoutesForAuthUsers = [
                    "PF_ChatBotPage",
                    "PF_AssessmentPage",
                    "BlankPage",
                    "PF_ChatBotEvaluationPage",
                    "PF_ChatbotAssessmentSharePage",
                    "DocPage"
                ];

                if (!chatbotRoutesForAuthUsers.includes(currentRoute.name) ) {
                    // Current page is not one of chatbot's pages (so it's a PRO or a public page).

                    if (store.getters["UserStore/getIsUserLoggedIn"] === true) {
                        router.push({ name: 'PF_ChatBotPage'});
                    }
                    else {
                        router.push({ name: 'LoginPage'});
                    }
                    return;
                }
            }

            // ===== AppType is NOT PF_CHATBOT_STUDY and it's NOT PF_CHATBOT_PUBLIC. =====
            if (store.getters["UserStore/getIsUserLoggedIn"] === true) {

                // ----- User is authenticated. -----

                if (currentRoute.path === '/auto-login/') {
                    // not used yet, the auto-login still has it's own login mechanism
                    //router.push('/auto-login');
                }
                else if (typeof currentRoute.query.assessment !== "undefined") {
                    router.push({
                        name: 'SummaryPage',
                        query: currentRoute.query
                    });
                }
                else if (typeof currentRoute.query.msitat !== "undefined") {
                    // The link contain msitat and no assessment identifier.
                    // The msitat give access to the assessment(s).
                    window.location.replace(window.location.origin + window.location.pathname + "#/assessment-list?msitat=" + currentRoute.query.msitat);
                }
                else if (window.location.search.length > 0 && window.location.search.indexOf("?token=") !== -1) {
                    let tokenUrlParam = window.location.search;
                    window.location.replace(window.location.origin + window.location.pathname + "#/summary" + tokenUrlParam);
                }
                else if (window.location.pathname.length > 0
                        && window.location.pathname.indexOf("/voucher") !== -1
                        && store.getters["TranslationStore/getVoucherData"] !== null
                        && typeof store.getters["TranslationStore/getVoucherData"].productCode !== "undefined"
                        && store.getters["TranslationStore/getVoucherData"].productCode !== null
                        && store.getters["TranslationStore/getVoucherData"].productCode.length > 0) {

                    // For URLs like "/voucher?v=<token>", remove voucher part of the URL and redirect to PFI Chatbot's assessment (having the product automatically preselected).
                    store.commit('ChatBotStore/setCurrentAssessmentStatus', store.getters["ChatBotStore/getAssessmentStatuses"].PRODUCT_LIST); // Simulate a visit on Chatbot's Product List page. This way we will make AssessmentPage to think that we are coming from product list page.
                    store.commit("ChatBotStore/setClickedProduct", {
                        code: store.getters["TranslationStore/getVoucherData"].productCode
                    });

                    // Remove "/voucher" from the URL and remove url query params too.
                    // @TODO Only remove "v" param. Now all other params that may be in the URL are removed.
                    let newPathname = window.location.pathname.replace("/voucher", "");
                    // Make sure that newPathname always has a trailing slash.
                    if (newPathname === "") {
                        newPathname = "/";
                    }
                    else if (newPathname.slice(-1) !== "/") {
                        newPathname = newPathname + "/";
                    }

                    let newLocation = window.location.origin + newPathname + window.location.hash;
                    history.replaceState(null, null, newLocation);

                    router.push({name: 'PF_AssessmentPage'});
                }
                else if (currentRoute.name === 'LoginPage') {
                    if (window.location.search.indexOf("?msitat=") !== -1 || window.location.search.indexOf("&msitat=") !== -1) {
                        if (window.location.search.indexOf("?assessment=") !== -1 || window.location.search.indexOf("&assessment=") !== -1) {
                            window.location.replace(window.location.origin + window.location.pathname + "#/summary" + window.location.search);
                        }
                        else {
                            window.location.replace(window.location.origin + window.location.pathname + "#/assessment-list" + window.location.search);
                        }
                    }
                    else if (store.getters["UserStore/getCurrentAppType"] === store.getters["UserStore/getAppTypes"].PF_CHATBOT) {
                        router.push({name: 'PF_ChatBotPage'});
                    }
                    else {
                        let sessionStorageHomeRouteName = sessionStorage.getItem("smass-home-route");
                        if (sessionStorageHomeRouteName !== null && sessionStorageHomeRouteName === "PF_ChatBotPage") {
                            router.push({name: 'PF_ChatBotPage'});
                        }
                        else {
                            router.push({name: 'HomePage'});
                        }
                    }
                }
                else {
                    // The user has probably hit 'f5' and the page has reloaded. We leave the user on the page where he is
                }
            }
        }

    });

    // ==================================
    // Export
    // ==================================

    // Globally set a computed property so we can use {{ text() }} in templates without re-declaring in each component.
    Vue.mixin({
        computed: {
            text: () => translateText
        }
    });

    // Export as instance method. Needed for translating texts in Vuex stores.
    Vue.prototype.$text = translateText;

};

export default TranslationPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/TranslationPlugin.js